// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.img-wrap[data-v-d205efa0]{\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n   margin-bottom: 20px;\n}\n.img-content[data-v-d205efa0]{\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
